import { Box, Button, FormLabel, MenuItem, Select, Typography } from "@mui/material"
import { useLocation } from "react-router-dom"
import { Back } from "../../../components/public/Button";
import { useEffect, useState } from "react";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { MapSeparateMapping } from "../../../components/Table/mapping-function/TableMapping";
import { store } from "../../../store";
import { useSelector } from "react-redux";

export const SeparateMapping = () => {
    const [filter1, setFilter1] = useState(null);
    const location = useLocation();
    const [tab, setTab] = useState(location?.state?.tab);
    const [tabName, setTabName] = useState(location?.state?.tabName);
    const [dropDownName, setDropDownName] = useState(null)
    const [tableData, setTableData] = useState(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4));
    // const [tableData, setTableData] = useState(MapSeparateMapping(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4), tab));
    const fn = MapSeparateMapping(tableData, tab)
    const tdd = fn()
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const id = useSelector((s) => s?.adminslice?.id)

    let prop = {
        title: 'Activity Table',
        tableStyle: { OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
        filteredData: tdd,
        rowsPerPage,
        page,
        setPage,
        borderBoxStyle: { px: 0 },
        goto: true,
    }
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("tab")) {
            // setTab(params.get("tab"));
            switch (params.get("tab")) {
                case "0": { // Compare as a string
                    setDropDownName({
                        name: 'Role',
                        menuTitle: <MenuItem sx={{ display: 'none' }} value={null} disabled>
                            Select Role
                        </MenuItem>,
                        down: <>
                            <MenuItem value='Super Admin' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Super Admin</MenuItem>
                            <MenuItem value='Admin' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Admin</MenuItem>
                            <MenuItem value='Customer' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Customer</MenuItem>
                        </>
                    });
                    break;
                }
                case "1":
                    setDropDownName({
                        name: 'Plan Role',
                        menuTitle: <MenuItem sx={{ display: 'none' }} value={null} disabled>
                            Select Plan Role
                        </MenuItem>,
                        down: <>
                            <MenuItem value='Project Owner' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Project Owner</MenuItem>
                            <MenuItem value='Stakeholder' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Stakeholder</MenuItem>
                            <MenuItem value='Team Member' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Team Member</MenuItem>
                        </>
                    });
                    // setDropDownName('Plan Role');
                    break;
                case "2":
                    setDropDownName({
                        name: 'Report',
                        menuTitle: <MenuItem sx={{ display: 'none' }} value={null} disabled>
                            Select Report
                        </MenuItem>,
                        down: <>
                            <MenuItem value='Health Report' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Health Report</MenuItem>
                            <MenuItem value='Project Report' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Project Report</MenuItem>
                            <MenuItem value='My Task Report' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>My Task Report</MenuItem>
                            <MenuItem value='Schedule Analysis Report' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Schedule Analysis Report</MenuItem>
                        </>
                    });
                    // setDropDownName('Report');
                    break;
                case "3":
                    setDropDownName({
                        name: 'Plan',
                        menuTitle: <MenuItem sx={{ display: 'none' }} value={null} disabled>
                            Select Plan
                        </MenuItem>,
                        down: <>
                            <MenuItem value='Current Plan' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>Current Plan</MenuItem>
                            <MenuItem value='New Plan' sx={{ fontSize: '12px', fontWeight: '400', color: '#797F8F' }}>New Plan</MenuItem>
                        </>
                    });
                    // setDropDownName('Plan');
                    break;
                default:
                    setDropDownName(null);
            }
            if (params.get("tabName")) {
                setTabName(params.get("tabName"))
            }
            
        }
    }, [location.search]);
    return (
        <Box>
            <Back prop={{ txt: tabName }} />
            <Box>
                <Typography sx={{ color: "#000000" }}>
                    {dropDownName?.name}
                </Typography>
                <Select
                    displayEmpty
                    size='small'
                    value={filter1}
                    onChange={(e) => setFilter1(e.target.value)}
                    sx={{
                        width: "170px",
                        height: "40px",
                        pr: '5px !important',
                        "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#D0D5DD",
                        },
                        "&.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
                            pr: 0
                        },
                    }}>
                    {dropDownName?.menuTitle}
                    {dropDownName?.down}
                </Select>
            </Box>
            <PackageTable prop={prop} />
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button disableRipple sx={{ color: '#474747', background: 'transparent', border: '1px solid #474747', textTransform: 'capitalize', '&:hover': { color: '#474747', background: 'transparent', border: '1px solid #474747', } }}>Back</Button>
                <Button disableRipple sx={{ ml: 1, color: '#fff', background: '#FF2800', border: '1px solid #FF2800', textTransform: 'capitalize', '&:hover': { color: '#fff', background: '#FF2800', border: '1px solid #FF2800', } }}>Next</Button>
            </Box>
        </Box>
    )
}